module.exports = __webpack_public_path__ + "img/banner_nanirestaurant-big.a6f0f76.JPG";